export const myFavListData = [
    {
        id: 1,
        groupName: "Visit Reports",
        favTitle: "Average Field Visits By Xitij",
        reportType: "avareagefieldvisitbyrep",
        filters: [
            {
                id: 1,
                reportsFavId: 1,
                columnName: "main_date",
                filterValue: "today",
                valueDataType: "string",
                fromDate: "",
                toDate: ""
            },
            {
                id: 2,
                reportsFavId: 1,
                columnName: "repName",
                filterValue: "xitij ",
                valueDataType: "string",
                fromDate: "",
                toDate: ""
            }
        ]
    },
    {
        id: 2,
        groupName: "Visit Reports",
        favTitle: "Account Field Visits By Xitij",
        reportType: "getaccountfieldvisithistorybyrep",
        filters: [
            {
                id: 3,
                reportsFavId: 2,
                columnName: "main_date",
                filterValue: "custom",
                valueDataType: "string",
                fromDate: "09-01-2022",
                toDate: "09-23-2022"
            },
            {
                id: 4,
                reportsFavId: 2,
                columnName: "username",
                filterValue: "xitij ",
                valueDataType: "string",
                fromDate: "",
                toDate: ""
            },
            {
                id: 5,
                reportsFavId: 2,
                columnName: "businessname",
                filterValue: "Type charger",
                valueDataType: "string",
                fromDate: "",
                toDate: ""
            }
        ]
    },
    {
        id: 3,
        groupName: "Visit Reports",
        favTitle: "Account Field Visits By Sanjeev",
        reportType: "getaccountfieldvisithistorybyrep",
        filters: [
            {
                id: 6,
                reportsFavId: 3,
                columnName: "main_date",
                filterValue: "this month",
                valueDataType: "string",
                fromDate: "",
                toDate: ""
            },
            {
                id: 7,
                reportsFavId: 3,
                columnName: "username",
                filterValue: "sanjeev ",
                valueDataType: "string",
                fromDate: "",
                toDate: ""
            }
        ]
    }
];


